import React from 'react';
import Attachment from '../../../../../components/NewAttachment/NewAttachment';
import styles from '../OfficeDocuments.module.scss';

const DocumentList = ({
  items,
  getAttachmentUrl,
  allDocs,
  onDeleteDocument,
}) => {
  return (
    <ul className={styles.list}>
      {items.map((attachment) => (
        <li key={attachment.id}>
          <Attachment
            attachments={allDocs}
            attachment={attachment}
            getAttachmentUrl={getAttachmentUrl}
            onDeleteAttachment={onDeleteDocument}
            ignoreCanBeDeleted
          />
        </li>
      ))}
    </ul>
  );
};

export default DocumentList;
